const GET_ORGANIZATION_AVAILABLE_PATH = '/organization/available';
export { GET_ORGANIZATION_AVAILABLE_PATH };
